import { render, staticRenderFns } from "./SurveyShow.vue?vue&type=template&id=1bb7b542"
import script from "./SurveyShow.vue?vue&type=script&lang=ts"
export * from "./SurveyShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports